import { RequestState } from '../../types'

export type PartnerSummaryState = {
  subscriptionsAddedMonth: number
  subscriptionsDeactivatedMonth: number
  totalSubscriptions: number
  trialSubscriptions: number
  requestState: RequestState
}

export type SubscriptionChartDataState = {
  data: ChartLine[] | undefined
  requestState: RequestState
}

export type ChartPoint = {
  x: string
  y: string
}

export type ChartLine = {
  id: string
  data: ChartPoint[]
}

export type DashboardState = {
  partnerSummary: PartnerSummaryState
  subscriptionChartData: SubscriptionChartDataState
}

export const initialDashboardState = {
  partnerSummary: {
    subscriptionsAddedMonth: -1,
    subscriptionsDeactivatedMonth: -1,
    totalSubscriptions: -1,
    trialSubscriptions: -1,
    requestState: RequestState.NotLoaded
  },
  subscriptionChartData: {
    data: undefined,
    requestState: RequestState.NotLoaded
  }
}

